import { FiltersController, IPredicate, FiltersDateRange } from '@centra/centra-ui'
import React, { FC } from 'react'

interface IFilterComponentDateProps {
  filterName: string
  predicate: IPredicate[]
  controller: FiltersController
  notInModal?: boolean
}

export const FilterComponentDate: FC<IFilterComponentDateProps> = ({ controller, notInModal }) => {
  return (
    <FiltersDateRange
      controller={controller}
      isInModal={!notInModal}
      filterName="createdFrom"
      modalSize="md"
      staticLabel="Период создания"
    />
  )
}
